import { inlines } from './inlines';
export var taskItem = function (node, nestedLevel, _a) {
    var context = (_a === void 0 ? {} : _a).context;
    var result = '';
    node.forEach(function (n) {
        // Generate stars based on depth
        var prefix = Array(nestedLevel)
            .fill('*')
            .join('');
        if (node.attrs.state === 'DONE') {
            result += prefix + " -" + inlines(n, { context: context }) + "-";
        }
        else {
            result += prefix + " " + inlines(n, { context: context });
        }
    });
    return result;
};
//# sourceMappingURL=taskItem.js.map